import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { useMenuItem } from "./useMenuItem.mjs";
const MenuItem = ({
  children,
  onClick,
  data,
  tone,
  badge,
  icon,
  id
}) => {
  const { menuItemProps, MenuItemChildren } = useMenuItem({
    tone,
    onClick,
    data,
    id
  });
  return /* @__PURE__ */ jsx(Box, { ...menuItemProps, component: "button", type: "button", children: /* @__PURE__ */ jsx(MenuItemChildren, { tone, leftSlot: icon, badge, children }) });
};
MenuItem.__isMenuItem__ = true;
export {
  MenuItem
};
